module.exports = {
  messages: {
    PROFILE_ERROR_SOMETHING_WENT_WRONG:
      'Etwas hat nicht geklappt. Probiere es bitte später noch einmal.',
    PROFILE_LO_FE_ALPHABETIZED_DIRECTORY_HEADING:
      '21 Mio. XING Mitglieder, von A bis Z',
    PROFILE_LO_FE_ALPHABETIZED_DIRECTORY_SUB_HEADING: 'Nachname:',
    PROFILE_LO_FE_BENEFITS_BUTTON_CTA: 'Jetzt registrieren',
    PROFILE_LO_FE_BENEFITS_COMMUNITY_TEXT:
      'Entdecke mit XING genau den Job, der wirklich zu Dir passt.',
    PROFILE_LO_FE_BENEFITS_COMMUNITY_TITLE: 'Über eine Million Jobs',
    PROFILE_LO_FE_BENEFITS_FREE_TEXT:
      'Knüpf neue Kontakte und erhalte Impulse für ein besseres Job-Leben.',
    PROFILE_LO_FE_BENEFITS_FREE_TITLE: '22 Mio. Mitglieder',
    PROFILE_LO_FE_BENEFITS_HEADLINE: 'XING – Das Jobs-Netzwerk',
    PROFILE_LO_FE_BENEFITS_NETWORK_TEXT:
      'Lass Dich finden von Arbeitgebern und über 20.000 Recruiter·innen.',
    PROFILE_LO_FE_BENEFITS_NETWORK_TITLE: 'Persönliche Job-Angebote',
    PROFILE_LO_FE_LANGUAGE_SKILLS_HEADLINE: 'Sprachen',
    PROFILE_LO_FE_LANGUAGE_SKILLS_LEVEL_1: 'Grundlagen',
    PROFILE_LO_FE_LANGUAGE_SKILLS_LEVEL_2: 'Gut',
    PROFILE_LO_FE_LANGUAGE_SKILLS_LEVEL_3: 'Fließend',
    PROFILE_LO_FE_LANGUAGE_SKILLS_LEVEL_4: 'Muttersprache',
    PROFILE_LO_FE_LEGAL_NOTICE_HEADLINE: 'Impressum',
    PROFILE_LO_FE_LEGAL_NOTICE_SUB_HEADLINE:
      'Rechtliche Hinweise von {displayName}',
    PROFILE_LO_FE_MEMBERSHIP_TEXT:
      'Schon als Basis-Mitglied kannst Du Deine Job-Suche deutlich optimieren.',
    PROFILE_LO_FE_MEMBERSHIP_TITLE: 'Kostenlos profitieren ',
    PROFILE_LO_FE_SIGNUP_LAYER_HEADLINE:
      'Willst Du noch mehr über {firstName} wissen?',
    PROFILE_LO_FE_SIGNUP_LAYER_LOGIN_CTA: 'Jetzt einloggen',
    PROFILE_LO_FE_SIGNUP_LAYER_SUB_HEADLINE:
      'Dann logg Dich ein oder registrier Dich bei XING – kostenlos und in nur 2 Minuten!',
    PROFILE_LO_FE_SIMILAR_PROFILES_HEADLINE:
      'XING Mitglieder mit ähnlichen Profilangaben',
    PROFILE_LO_FE_SKILLS_HEADLINE: 'Fähigkeiten und Kenntnisse',
    PROFILE_LO_FE_STICKY_LAYER_HEADLINE:
      'Willst Du mehr über {displayName} wissen?',
    PROFILE_LO_FE_STICKY_LAYER_SUB_HEADLINE:
      'Dann logg Dich ein oder registrier Dich bei XING – kostenlos und in nur 2 Minuten!',
    PROFILE_LO_FE_TIMELINE_CURRENT: 'Bis heute',
    PROFILE_LO_FE_TIMELINE_EDUCATION_HEADLINE:
      'Ausbildung von {firstName} {lastName}',
    PROFILE_LO_FE_TIMELINE_HEADLINE: 'Werdegang',
    PROFILE_LO_FE_TIMELINE_WORK_EXPERIENCE_HEADLINE:
      'Berufserfahrung von {firstName} {lastName}',
    PROFILE_LO_FE_UNFENCED_CTA:
      'Logg Dich jetzt ein, um das ganze Profil zu sehen.',
    PROFILE_LO_FE_USER_BAG_HEADLINE_FEMALE:
      'Suchst Du eine andere  {firstName} {lastName}?',
    PROFILE_LO_FE_USER_BAG_HEADLINE_MALE:
      'Suchst Du einen anderen {firstName} {lastName}?',
    PROFILE_LO_FE_USER_BAG_HEADLINE_NONE:
      'Andere XING Mitglieder, die {firstName} {lastName} heißen',
    PROFILE_LO_FE_USER_BAG_SHOW_MORE_CTA: 'Weitere Mitglieder',
    PROFILE_LO_FE_XING_ID_CTA: 'Logg Dich ein, um alle Einträge zu sehen.',
    PROFILE_LO_PREVIEW_ALREADY_LOGGED_IN_V2:
      'Das ist hier normalerweise zu sehen: Wer Dein Profil besucht, aber nicht eingeloggt ist, kann sich hier entweder einloggen oder registrieren.\n(In dieser Profil-Vorschau zeigen wir dies aber nicht an.)',
    PROFILE_LO_PREVIEW_CANT_REPORT:
      'Du kannst kein Profil melden, wenn es sich im Vorschau-Modus befindet.',
    PROFILE_LO_PREVIEW_CLOSE_PREVIEW: 'Vorschau schließen',
    PROFILE_LO_PREVIEW_INFO_BANNER:
      'So sieht Dein Profil für andere aus, wenn sie nicht bei XING eingeloggt sind.',
    PROFILE_LO_REPORT_PROFILE_LINK: 'Profil melden',
    PROFILE_LO_XING_ID_MAIN_CTA_BUTTON: 'Ganzes Profil ansehen',
    PROFILE_LO_XING_ID_MAIN_CTA_BUTTON_RECURRING_USER: 'Einloggen',
    PROFILE_LO_XINGID_MORE: 'Mehr',
    USER_FLAG_ERROR_PARAGRAPH_1:
      'Diese Info können wir gerade leider nicht zeigen.',
    USER_FLAG_ERROR_PARAGRAPH_2: "Versuch's bitte später nochmal.",
    USER_FLAG_LOADING: 'Einen Moment bitte ...',
  },
};
